export default {"src":"/_next/static/media/tableDelete.735e586d.svg","height":14,"width":13};